<div class="custom-select-filter-panel layout-column" appBringozIdGenerator="custom-select-filter-panel">

  <!--Search Box-->
  <div class="layout-row layout-align-start-center padding-10">
    <!--Select All: disabled rather than hidden when nothing matches, so the search box does not jump-->
    <bz-checkbox class="margin-right-10"
                 size="md"
                 appBringozIdGenerator="custom-select-filter-select-all"
                 [ariaLabel]="'Select All' | translate"
                 [disabled]="isEmpty()"
                 [checked]="allVisibleSelected()"
                 [indeterminate]="someVisibleSelected()"
                 (checkedChange)="onToggleAll()">
    </bz-checkbox>

    <bz-search-input class="flex"
                     appBringozIdGenerator="custom-select-filter-search-input"
                     [placeholder]="'Search' | translate"
                     [ariaLabel]="'Search' | translate"
                     [value]="queryString()"
                     (valueChange)="onQueryChange($event)">
    </bz-search-input>
  </div>

  <bz-divider></bz-divider>

  @if (isEmpty()) {
    <!--Empty State-->
    <div class="flex layout-column layout-align-center-center fade-element-in-only">
      <bz-empty-state [title]="'No Results Found' | translate"></bz-empty-state>
    </div>
  } @else {
    <!--List-->
    <cdk-virtual-scroll-viewport class="flex select-filter-list" [itemSize]="itemSize">
      <div *cdkVirtualFor="let option of visibleOptions(); trackBy: trackById"
           class="select-filter-item layout-row layout-align-start-center">
        <bz-checkbox size="md"
                     appBringozIdGenerator="custom-select-filter-option"
                     [checked]="!!selectedKeys()[option.id]"
                     (checkedChange)="onToggle(option.id, $event)">
          {{ option.label }}
        </bz-checkbox>
      </div>
    </cdk-virtual-scroll-viewport>
  }

  <bz-divider></bz-divider>

  <div class="layout-row layout-align-start-center padding-5">
    <bz-button variant="tertiary"
               tone="primary"
               appBringozIdGenerator="custom-select-filter-cancel-button"
               (clicked)="onCancel()">
      <span>{{ 'Cancel' | translate }}</span>
    </bz-button>

    <span class="flex"></span>

    <bz-button variant="outline"
               tone="primary"
               class="margin-right-5"
               appBringozIdGenerator="custom-select-filter-reset-button"
               (clicked)="onReset()">
      <span>{{ 'Reset' | translate }}</span>
    </bz-button>

    <bz-button tone="secondary"
               appBringozIdGenerator="custom-select-filter-submit-button"
               (clicked)="onSubmit()">
      <span>{{ 'Submit' | translate }}</span>
    </bz-button>
  </div>

</div>
